<template>
    <div class="d-flex justify-content-center align-content-center">
        <a class="btn btn-dark my-6 px-4 py-3" :href="url" v-if="url">{{'Go to exam panel' | translate}}</a>
    </div>
</template>

<script>
export default {
computed: {
    url() {
        return `/exam/${this.$route.params.exam}`
    },
},
}
</script>

<style>

</style>